import { MOBILE } from '@/scripts/constants/media-query'

export default {
  name: 'rb-dynamic-grid-smart-',
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    filteredSlots() {
      return this.$slots.default.filter((slot) => !!slot.tag)
    },
    currentSlot() {
      return this.filteredSlots[this.index]
    },
    isMobile() {
      if (this.$mq === MOBILE) {
        return true
      } else {
        return false
      }
    },
  },
  render(createElement) {
    const isMocoTile = this.currentSlot.componentOptions?.tag === ''
    if (isMocoTile && this.isMobile) {
      this.currentSlot.componentOptions.propsData.internalContent = false
    }

    if (this.filteredSlots.length === 2) {
      if (this.isMobile) {
        return createElement('div', { class: 'col-6' }, [this.currentSlot])
      } else {
        return createElement('div', { class: 'col-sm-6 col-md-12' }, [this.currentSlot])
      }
    } else if (this.filteredSlots.length === 3) {
      if (this.index === 0) {
        return createElement('div', { class: 'col-12 no-squared' }, [this.currentSlot])
      } else {
        return createElement('div', { class: 'col-6' }, [this.currentSlot])
      }
    } else if (this.filteredSlots.length === 1) {
      return createElement('div', { class: 'col-12' }, [this.currentSlot])
    } else {
      return createElement('div', { class: 'col-6' }, [this.currentSlot])
    }
  },
}
